import { AxiosResponse } from "axios";
import { api } from "../api";
import { StandardResponse } from "../interfaces/Common";
import { Reference } from "../interfaces/Reference";

export async function getReferences(params?: { pageNo?: number; isFavorite?: boolean; }): Promise<StandardResponse<Reference[]>> {
    const response: AxiosResponse<StandardResponse<Reference[]>> = await api.get("/references", {
        params
    });
    return response.data;
}

export async function getReferenceById(referenceId: string): Promise<StandardResponse<Reference>> {
    const response: AxiosResponse<StandardResponse<Reference>> = await api.get(`/references/${referenceId}`);
    return response.data;
}

export async function searchReferences(params?: { keyword?: string; isFavorite?: boolean; }): Promise<StandardResponse<Reference[]>> {
    const response: AxiosResponse<StandardResponse<Reference[]>> = await api.get("/search/references", {
        params
    });
    return response.data;
}

export async function markAsFavorite(referenceId: string, action: string): Promise<StandardResponse<string[]>> {
    const response: AxiosResponse<StandardResponse<string[]>> = await api.post('/users/references/actions', {
        referenceId,
        action
    });
    return response.data;
}
